/**
 * KAN-819: actions of a row on "Лиды по теплоте". "Карточка" opens the client
 * card (/clients/<id>), "Переписка" opens the same conversation modal as the
 * dashboard attention list (?dialog=<clientId>, TranscriptDialogHost in the
 * layout loads the client's latest estimate). The text is shown on wide
 * screens; narrow ones keep the icon, aria-label and title.
 */
import { Link } from 'react-router-dom';
import { IdCard, MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useDialogParam } from '@/hooks/useDialogParam';

interface LeadRowActionsProps {
  clientId: string;
  /** Name shown in the row: modal title and accessible labels. */
  name: string;
}

const ACTION_CLASS = 'h-8 gap-1.5 px-2 text-gray-700';
const LABEL_CLASS = 'hidden xl:inline';

export function LeadRowActions({ clientId, name }: LeadRowActionsProps) {
  const { openDialog } = useDialogParam();
  const cardLabel = `Открыть карточку клиента ${name}`;
  const chatLabel = `Открыть переписку ${name}`;
  return (
    <div className="flex items-center gap-1 whitespace-nowrap">
      <Button asChild variant="outline" size="sm" className={ACTION_CLASS}>
        <Link to={`/clients/${clientId}`} aria-label={cardLabel} title={cardLabel} data-testid="lead-open-card">
          <IdCard className="h-4 w-4" aria-hidden="true" />
          <span className={LABEL_CLASS}>Карточка</span>
        </Link>
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={ACTION_CLASS}
        aria-label={chatLabel}
        title={chatLabel}
        data-testid="lead-open-chat"
        onClick={() => openDialog({ clientId, hint: { title: name } })}
      >
        <MessageSquare className="h-4 w-4" aria-hidden="true" />
        <span className={LABEL_CLASS}>Переписка</span>
      </Button>
    </div>
  );
}
